import React from 'react';
import { ServiceDetailPage } from '../../components/ServiceLayout/ServiceDetailPage';
import planImg from '../../images/offers-plan.jpg';

export const CustomLogisticsPage = () => (
  <ServiceDetailPage
    meta={{
      title: 'Custom Logistics Plan — Renuit Logistics',
      description: 'Full supply chain audit, dedicated account management, and integrated freight + warehousing solutions for Southeast US shippers.',
      canonical: 'https://www.renuit.pro/services/custom-logistics',
    }}
    hero={{
      image: planImg,
      tag: 'Built Around You',
      heading: 'Custom Logistics Plan',
      subheading: 'For businesses with complex needs, recurring freight, or supply chains that don\'t fit neatly into a single box — we design a solution that does.',
    }}
    detail={{
      heading: 'A Program Built Around Your Operation',
      subheading: 'We start with a full audit of your current logistics costs, carrier relationships, and fulfillment gaps. We then build a written program covering freight, warehousing, and last-mile — with one point of accountability.',
      features: [
        'Full supply chain and cost structure audit',
        'Custom carrier selection and negotiation',
        'Integrated freight + warehouse + delivery management',
        'Dedicated account manager and escalation path',
        'Monthly reporting and performance reviews',
        'Scalable agreements that grow with your volume',
        'Technology integration with your existing systems',
      ],
      image: planImg,
    }}
    steps={[
      { n: '01', title: 'Discovery call', body: 'We spend 30–60 minutes understanding your lanes, volumes, pain points, and growth plans. No cost, no commitment.' },
      { n: '02', title: 'Supply chain audit', body: 'We review your current freight spend, carrier performance, and warehousing setup to identify what is costing you — and what is fixable.' },
      { n: '03', title: 'Proposal', body: 'We deliver a written proposal with a custom logistics program, projected savings, and a clear SLA.' },
      { n: '04', title: 'Onboarding', body: 'Average onboarding is 48 hours. Your account manager handles carrier setup, system integration, and first-shipment execution.' },
    ]}
    faq={[
      { q: 'Is the initial audit free?', a: 'Yes. The discovery call and preliminary audit are complimentary. A written proposal with detailed findings comes after — at no cost and no obligation.' },
      { q: 'How long does onboarding take?', a: 'Our average onboarding for a new custom logistics account is 48 hours. Complex multi-lane or multi-facility programs may take up to one week.' },
      { q: 'Do you require long-term contracts?', a: 'We typically propose 12-month service agreements for custom programs, with performance review clauses. Month-to-month arrangements are available on a case-by-case basis.' },
      { q: 'Can you replace our current 3PL?', a: 'Yes — and we do this regularly. We will do a parallel review period during transition so nothing is disrupted until you are confident in the new setup.' },
    ]}
    cta={{
      heading: 'Let\'s Design Your Logistics Program',
      subheading: 'Start with a no-pressure 30-minute discovery call.',
      primaryText: 'Schedule a Discovery Call',
      primaryTo: '/quote?type=consultation',
      phone: '(786) 628-3731',
    }}
  />
);
